import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExceptionComponent} from './exception/exception.component';
import {IconsModule} from '../icons/icons.module';
import {ExceptionService} from './exception/exception.service';

@NgModule({
    declarations: [
        ExceptionComponent
    ],
    entryComponents: [
        ExceptionComponent
    ],
    imports: [
        CommonModule,
        IconsModule
    ],
    providers: [
        ExceptionService
    ]
})
export class ExceptionsModule {
}
